import { tsValidateValue } from '@nu-art/ts-common';
import { findingSortMethods } from './types.js';
export const Validator_FindingSortMethod = tsValidateValue([...findingSortMethods]);
//# sourceMappingURL=validation.js.map